/**
 * @fileOverview Modifier functions for cricket specific data.
 *
 * This file contains functions which modify data structures for common sports
 * with cricket specific data
 */

import selectn from 'selectn'

/**
 * Modifier functions
 * @type {Object}
 */
export const modifiers = {
  /**
   * Update gamestrip data
   * @param  {Object} gameStrip gamestrip data
   * @return {object}           Updated gamestrip
   */
  gameStrip : function (gameStrip = {}) {
    let winnerClass = gameStrip.winnerClass || ''
    let winnerClassMobile = gameStrip.winnerClassMobile || ''
    let winnerClassFeature = gameStrip.winnerClassFeature || ''
    let gameState = gameStrip.gameState || ''
    // check if home team batted first based on order    
    let homeTeamOrder = selectn('teams.home.order', gameStrip)
    let homeTeamBattedFirst =homeTeamOrder == 1 ? true : false    
    if (gameState !== 'pregame') {
      /**
       * Only if match has a winner -
       * If home team has not batted first, it will be shown on right side.
       * So swap winner class. (By default it assumes that home team is on left)
       */
      //console.info('homeTeamBattedFirst, winnerClass', homeTeamBattedFirst, winnerClass)
      if (winnerClass !== '' && homeTeamBattedFirst === false) {
        gameStrip.winnerClass = winnerClass === 'team-a-winner' ? 'team-b-winner' : 'team-a-winner'
        gameStrip.winnerClassMobile = winnerClassMobile === 'cscore--home-winner' ? 'cscore--away-winner' : 'cscore--home-winner'
        gameStrip.winnerClassFeature = winnerClassFeature === 'cscore__home--winner' ? 'cscore__away--winner' : 'cscore__home--winner'
      }
    }
    return { homeTeamBattedFirst, ...gameStrip }
  }
}

export default modifiers



// WEBPACK FOOTER //
// ../app/lib/transform/modifiers/cricket.js